/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { UserProfile } from '@/types/auth.types'

interface UserDeleteDialogProps {
  user: UserProfile | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function UserDeleteDialog({
  user,
  open,
  onOpenChange,
  onConfirm,
}: UserDeleteDialogProps) {
  if (!user) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Smazat uživatele</DialogTitle>
          <DialogDescription>
            Opravdu chcete smazat uživatele{' '}
            <strong>
              {user.firstName} {user.lastName}
            </strong>{' '}
            ({user.email})? Tuto akci nelze vrátit zpět.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Zrušit
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Smazat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
